<template>
  <div class="starCoinRank">
    <div class="star-main">
      <div class="back" @click="handleBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="tip" @click="lookRoles">?</div>
      <!-- 左侧 -->
      <div class="left-container">
        <div class="title classname" v-if="$route.query.classesName">
          {{ $route.query.classesName }}
        </div>
        <div class="title">
          <div>星币排行</div>
          <div class="tabs" v-if="urlType === 'starCoin'">
            <span :class="{'tab-item':true, active:rankType === 1}" @click="handleChangeRankType(1)">班级榜</span>
            <span :class="{'tab-item':true, active:rankType === 0}" @click="handleChangeRankType(0)">总排行</span>
          </div>
        </div>
        <div class="bks-box">
          <img src="@/assets/image/stuUI/bks@2x.png" alt="" />
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right-container">
        <!-- 奖台 -->
        <div class="podium">
          <div class="podium-item top1">
            <div class="pic-box">
              <div class="pic-group">
                <img class="headring" src="@/assets/image/stuUI/top1head@2x.png" alt="" />
                <img class="head" v-if="rankList[0]" :src="rankList[0].headUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
              </div>
              <div class="star-num">
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <span>{{ rankList[0] ? rankList[0].starNum : '' }}</span>
              </div>
              <span class="name">{{
                rankList[0] ? rankList[0].stuName : ''
              }}</span>
            </div>
            <div class="pic-base">
              <span>TOP.1</span>
              <img src="@/assets/image/stuUI/top1@2x.png" alt="" />
            </div>
          </div>
          <div class="podium-item top2">
            <div class="pic-box">
              <div class="pic-group">
                <img class="headring" src="@/assets/image/stuUI/top2head@2x.png" alt="" />
                <img class="head" v-if="rankList[1]" :src="rankList[1].headUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
              </div>
              <div class="star-num">
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <span>{{ rankList[1] ? rankList[1].starNum : '' }}</span>
              </div>
              <span class="name">{{
                rankList[1] ? rankList[1].stuName : ''
              }}</span>
            </div>
            <div class="pic-base">
              <span>TOP.2</span>
              <img src="@/assets/image/stuUI/top2@2x.png" alt="" />
            </div>
          </div>
          <div class="podium-item top3">
            <div class="pic-box">
              <div class="pic-group">
                <img class="headring" src="@/assets/image/stuUI/top3head@2x.png" alt="" />
                <img class="head" v-if="rankList[2]" :src="rankList[2].headUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
              </div>
              <div class="star-num">
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <span>{{ rankList[2] ? rankList[2].starNum : '' }}</span>
              </div>
              <span class="name">{{
                rankList[2] ? rankList[2].stuName : ''
              }}</span>
            </div>
            <div class="pic-base">
              <span>TOP.3</span>
              <img src="@/assets/image/stuUI/top3@2x.png" alt="" />
            </div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="list">
          <ul>
            <li v-for="(rankItem, index) in rankList" :key="rankItem.stuId">
              <div class="item-left">
                <span class="sort">{{ index + 1 }}</span>
                <div class="stu-info">
                  <div class="headPic">
                    <img :src="rankItem.headUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
                  </div>
                  <div v-if="rankItem.pendantUrl" class="pendanPic">
                    <img :src="rankItem.pendantUrl" ondragstart="return false" oncontextmenu="return false" alt="" />
                  </div>
                  <span class="name">{{ rankItem.stuName }}</span>
                </div>
              </div>
              <div class="item-right">
                <img src="@/assets/image/starCoin/starCoin@2x.png" alt="" />
                <span class="star-num">{{ rankItem.starNum }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 弹框：规则说明 -->
    <el-dialog title="规则说明" center :visible.sync="starRulesDialog" width="50%" :before-close="handleClose">
      <div class="star-rules">
        <div class="rules-box">
          <ul>
            <li>
              <div class="title"><span class="point"></span>什么是星币?</div>
              <div class="content">
                星币是一种虚拟积分奖励，小朋友在学习过程中可获得星币。在每节课程中获得的星币数量与本班级其他学员获得金币数量的比较。通过这种排名形式，希望小朋友能够持续的进行学习和完成周边的其他学习任务，在编程之旅中一往无前!
              </div>
            </li>
            <li>
              <div class="title">
                <span class="point"></span>星币有什么用途?
              </div>
              <div class="content">
                星币可以在客户端、小程序、“星币商城”中兑换丰富的实物奖品和虚拟商品。
              </div>
            </li>
            <li>
              <div class="title">
                <span class="point"></span>与其他同学星币数量一样时如何计算排名?
              </div>
              <div class="content">
                如果同学星币数额相同时，为了鼓励更积极完成学习任务的同学，会比较星币的获取时间越早达到当前星币数额的同学排名越高。
              </div>
            </li>
            <li>
              <div class="title"><span class="point"></span>如何获取星币?</div>
              <div class="content">
                <el-table :data="rulesData" style="width: 100%" border stripe :header-cell-style="{ background: '#f5f7fa', color: '#333' }">
                  <el-table-column prop="scene" label="场景" align="center" width="150">
                  </el-table-column>
                  <el-table-column prop="behavior" label="行为">
                  </el-table-column>
                </el-table>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  api_stuStuStarClassStarRank,
  api_stuStuStarStuClassStarRank,
  api_stuStuStarEduCampusStarRank
} from '@/api/javaApi'
export default {
  name: 'stuStarCoinRank',
  data: () => ({
    urlType: '',
    rankType: 1,
    rankList: [],
    starRulesDialog: false,
    rulesData: [
      { scene: '上课', behavior: '上课和老师互动' },
      { scene: '课堂创作', behavior: '完成上课创作、课后作业' },
      { scene: '考试', behavior: '考试达到标准' },
      { scene: '点名签到', behavior: '设置好奖励规则，系统自动发放星币' },
      // { scene: '分享', behavior: '分享学习报告，获得点赞' },
    ],
  }),
  created() {
    // console.log(this.$store.state.resource.picBaseUrl)
    const { type } = this.$route.query
    this.urlType = type;
    if (type === 'classes') {
      // 从班级进入
      this.stuStuStarClassStarRank()
    } else if (type === 'starCoin') {
      // 从星币进入
      this.stuStuStarStuClassStarRank()
    }
  },
  methods: {
    lookRoles() {
      console.log(this.starRulesDialog)
      this.starRulesDialog = true
    },
    handleClose() {
      this.starRulesDialog = false
    },
    handleBack() {
      this.$router.back()
    },
    handleChangeRankType(val) {
      this.rankType = val;
      if (val === 0) {
        this.stuStuStarEduCampusStarRank();
      } else {
        this.stuStuStarStuClassStarRank()
      }
    },
    // 不是学生端跳转进入
    stuStuStarClassStarRank() {
      api_stuStuStarClassStarRank({
        curriculumClassId: this.$route.query.curriculumClassId,
      }).then((res) => {
        console.log(res)
        this.rankList = res
        this.rankList.forEach((item) => {
          item.pendantUrl = item.pendantUrl
            ? this.$store.state.resource.picBaseUrl + item.pendantUrl
            : item.pendantUrl
        })
      })
    },
    // 从学生端跳转进入 班级排行
    stuStuStarStuClassStarRank() {
      api_stuStuStarStuClassStarRank().then((res) => {
        console.log(res)
        this.rankList = res
        this.rankList.forEach((item) => {
          item.pendantUrl = item.pendantUrl
            ? this.$store.state.resource.picBaseUrl + item.pendantUrl
            : item.pendantUrl
        })
      })
    },
    // 从学生端跳转进入 校区排行
    stuStuStarEduCampusStarRank() {
      api_stuStuStarEduCampusStarRank().then((res) => {
        console.log(res)
        this.rankList = res
        this.rankList.forEach((item) => {
          item.pendantUrl = item.pendantUrl
            ? this.$store.state.resource.picBaseUrl + item.pendantUrl
            : item.pendantUrl
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
/**定义函数 如果小于1440， * (1440-当前页面宽度) / 100 */
$page-width: var(--page-width);
@function px-to-vw($px) {
  @return $px / 19.2 * 1vw;
}
.starCoinRank {
  .star-main {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1009;
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    padding: 0 px-to-vw(165);
    background: url("../../../../assets/image/stuUI/stuBgBottom@2x.png") left
        bottom / 100% no-repeat,
      linear-gradient(180deg, #867ef0 0%, #5b50eb 100%);
    .back {
      position: absolute;
      top: px-to-vw(50);
      left: px-to-vw(70);
      display: flex;
      justify-content: center;
      align-items: center;
      width: px-to-vw(50);
      height: px-to-vw(50);
      background-color: rgba(216, 216, 216, 0.5);
      border-radius: 50%;
      color: #fff;
      font-size: px-to-vw(34);
      font-weight: bold;
      cursor: pointer;
      transition: opacity 0.25s;
      &:hover {
        opacity: 0.9;
      }
      &:active {
        opacity: 0.8;
      }
    }
    .tip {
      position: absolute;
      position: absolute;
      top: px-to-vw(65);
      right: px-to-vw(80);
      display: flex;
      justify-content: center;
      align-items: center;
      width: px-to-vw(50);
      height: px-to-vw(50);
      background-color: rgba(216, 216, 216, 0.5);
      border-radius: 50%;
      color: #fff;
      font-size: px-to-vw(34);
      font-weight: bold;
      cursor: pointer;
      transition: opacity 0.25s;
      &:hover {
        opacity: 0.9;
      }
      &:active {
        opacity: 0.8;
      }
    }
    .left-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: flex-end;
      width: 50%;
      padding: px-to-vw(115) px-to-vw(80) px-to-vw(50) 0;
      // padding: 0 px-to-vw(80) px-to-vw(50) 0;
      .title {
        position: relative;
        padding-bottom: px-to-vw(70);
        font-size: px-to-vw(40);
        font-family: AppleSystemUIFont;
        color: #ffffff;
        line-height: px-to-vw(71);
        letter-spacing: px-to-vw(6);
        text-align: center;
        font-style: normal;
        &.classname {
          padding-bottom: px-to-vw(0);
          font-size: px-to-vw(50);
          font-weight: bold;
        }
        .tabs {
          position: absolute;
          left: 50%;
          bottom: px-to-vw(20);
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          width: max-content;
          padding: px-to-vw(5) px-to-vw(15);
          background-color: rgba(255, 255, 255, 0.7);
          border-radius: px-to-vw(40);
          font-size: px-to-vw(16);
          line-height: normal;
          .tab-item {
            padding: px-to-vw(5) px-to-vw(15);
            background: #360052;
            border-radius: px-to-vw(40);
            color: #ffffff;
            letter-spacing: normal;
            cursor: pointer;
            &:first-child {
              margin-right: px-to-vw(10);
            }
            &.active {
              background: linear-gradient(
                90deg,
                #09b4fe 0%,
                #445afc 51%,
                #ae58d0 100%
              );
            }
          }
        }
      }
      .bks-box {
        flex: 1;
        height: 100%;
        overflow: hidden;
        img {
          // max-width: 628px;
          // max-width: 450px;
          // width: 100%;
          height: 100%;
        }
      }
    }
    .right-container {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 50%;
      padding: px-to-vw(80) 0 px-to-vw(50) px-to-vw(0);
      .podium {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: px-to-vw(65) px-to-vw(40) 0;
        .podium-item {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          &.top1 {
            order: 2;
            width: px-to-vw(215);
            top: px-to-vw(-10);
            .pic-box {
              width: px-to-vw(142);
              height: px-to-vw(142);
              top: px-to-vw(-80);
              .star-num {
                bottom: px-to-vw(10);
              }
              .name {
                transform: translateY(px-to-vw(-5));
              }
            }
            .pic-base {
              span {
                top: px-to-vw(100);
                font-size: px-to-vw(40);
              }
            }
          }
          &.top2 {
            order: 1;
            width: px-to-vw(172);
            .pic-box {
              width: px-to-vw(142);
              height: px-to-vw(142);
              top: px-to-vw(-90);
              .star-num {
                bottom: px-to-vw(10);
              }
              .name {
                transform: translateY(px-to-vw(-7));
              }
            }
          }
          &.top3 {
            order: 3;
            width: px-to-vw(182);
            .pic-box {
              width: px-to-vw(123);
              height: px-to-vw(132);
              top: px-to-vw(-90);
              .pic-group {
                .head {
                  width: 70%;
                  transform: translate(-50%, -48%);
                }
              }
              .star-num {
                bottom: px-to-vw(5);
              }
            }
          }
          .pic-box {
            position: absolute;
            z-index: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            .pic-group {
              position: relative;
              width: 100%;
              .headring {
                position: relative;
                width: 100%;
                z-index: 1;
              }
              .head {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 2;
                width: 66%;
                border-radius: 50%;
              }
            }
            .star-num {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              z-index: 3;
              display: flex;
              align-items: center;
              width: px-to-vw(70);
              height: px-to-vw(22);
              padding-left: px-to-vw(10);
              background: linear-gradient(90deg, #faa5c4 0%, #ee6799 100%);
              border-radius: px-to-vw(11);
              img {
                width: px-to-vw(16);
                height: px-to-vw(15);
              }
              span {
                padding-left: px-to-vw(5);
                font-weight: bold;
                font-size: px-to-vw(12);
                color: #ffffff;
                line-height: px-to-vw(14);
                text-align: center;
                font-style: normal;
              }
            }
            .name {
              font-weight: bold;
              font-size: px-to-vw(14);
              color: #333333;
              line-height: px-to-vw(20);
            }
          }
          .pic-base {
            position: relative;
            width: 100%;
            span {
              position: absolute;
              left: 50%;
              top: px-to-vw(80);
              z-index: 1;
              background: linear-gradient(
                155deg,
                #ffffff 0%,
                rgba(255, 255, 255, 0.5) 100%
              );
              background-clip: text;
              color: transparent;
              font-size: px-to-vw(30);
              font-weight: bold;
              transform: translateX(-50%);
            }
            img {
              width: 100%;
            }
          }
        }
      }
      .list {
        position: absolute;
        z-index: 1;
        top: px-to-vw(315);
        width: 100%;
        height: calc(100% - 19.53125vw);
        background: rgba(255, 255, 255, 0.7);
        box-shadow: inset 0px 0px 6px 0px #ffffff;
        border-radius: px-to-vw(12);
        backdrop-filter: blur(11.76470588235294px);
        overflow: hidden;
        ul {
          height: 100%;
          padding: px-to-vw(15) 0;
          overflow: auto;
          scrollbar-width: none; /* 可以是 'auto', 'thin', 'none' */
          scrollbar-color: #333 #ddd; /* 滚动条的颜色，先是滑块颜色，再是轨道颜色 */
          /* 针对IE的特定样式 */
          &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
          }
          &::-moz-scrollbar {
            width: 0px;
            height: 0px;
          }
          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: px-to-vw(74);
            margin-bottom: px-to-vw(10);
            padding: 0 px-to-vw(45);
            border-radius: px-to-vw(15);
            transition: all 0.25s;
            &:last-child {
              margin-bottom: 0;
            }
            &:hover {
              background: linear-gradient(
                180deg,
                #fbd6dd 0%,
                #fde9e8 47%,
                #feefe8 100%
              );
            }
            .item-left {
              display: flex;
              align-items: center;
              font-size: px-to-vw(14);
              font-weight: bold;
              .sort {
                width: px-to-vw(45);
              }
              .stu-info {
                position: relative;
                display: flex;
                align-items: center;
                .headPic {
                  position: relative;
                  z-index: 1;
                  width: px-to-vw(44);
                  height: px-to-vw(44);
                  border: px-to-vw(2) solid #ffa0c8;
                  border-radius: 50%;
                  overflow: hidden;
                  img {
                    width: 100%;
                  }
                }
                .pendanPic {
                  position: absolute;
                  left: px-to-vw(-22);
                  top: px-to-vw(-22);
                  z-index: 2;
                  width: px-to-vw(88);
                  // height: 50px;
                  // border-radius: 50%;
                  img {
                    width: 100%;
                  }
                }
                span {
                  padding-left: px-to-vw(25);
                }
              }
            }
            .item-right {
              display: flex;
              align-items: center;
              img {
                width: px-to-vw(24);
              }
              .star-num {
                width: px-to-vw(50);
                padding-left: px-to-vw(5);
                text-align: center;
                font-weight: bold;
                font-size: px-to-vw(16);
                color: #333333;
              }
            }
          }
        }
      }
    }
  }
  .star-rules {
    .rules-box {
      max-width: 1200px;
      margin: auto;
      padding: 40px;
      background: #ffffff;
      box-shadow: 0px 0px 4px 0px #f0f4f5;
      border-radius: 5px;
      border: 1px solid #f4f5f9;
      ul {
        li {
          .title {
            display: flex;
            align-items: center;
            padding-bottom: 10px;
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            .point {
              display: inline-block;
              width: 5px;
              height: 5px;
              margin-right: 10px;
              background: #1778ff;
              border-radius: 50%;
            }
          }
          .content {
            padding-bottom: 40px;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 21px;
            .el-table {
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
